import { Avatar, Card } from "antd";
import Button from "./button";
import { Link } from "react-router-dom";
import profileImage from "../../assets/icons/Avatar.png";

const ProfileCard = ({ name, business, imgSrc }) => {
  return (
    <Card className="border-2 border-gray-200 w-full xl:w-54.1 xl:h-11.4 bg-primaryPurple">
      <div className="flex xl:flex-row flex-col xl:justify-between xl:items-end items-center">
        <div className="flex ml-1.5 mt-1">
          <Avatar
            src={imgSrc ?? profileImage}
            className="mr-1 w-6 h-6 mt-1.5"
          />
          <div className="flex flex-col">
            <p className="text-white text-lg mb-0">{name}</p>
            <p className="text-grey mt-0">{business}</p>
          </div>
        </div>
        <div className="flex flex-col-reverse mr-1.5 ">
          <Link to="/main/settings/personal/settings">
            <Button
              title="Edit Profile"
              className="bg-primaryBlue w-11.4 !h-3 !rounded-sm mb-1"
            />
          </Link>
        </div>
      </div>
    </Card>
  );
};

export default ProfileCard;
